import React from 'react';
import { useDeleteRSSFeed } from 'services/rss-feeds/delete-rss-feed';
import { ShouldRender } from 'components/ShouldRender';
import { Button, Message } from 'semantic-ui-react';
import { FormattedMessage } from 'react-intl';
import { Text } from 'components/typography/Text';
import styles from './styles.module.scss';

export const DeleteFeed = ({ feed: { id, title }, onDelete }) => {
  const { isLoading, error, isError, deleteRSSFeed } = useDeleteRSSFeed({
    onSuccess: () => {
      onDelete();
    },
  });

  return (
    <div className={styles.deleteFeed}>
      <Text large>
        <FormattedMessage
          id="deleteFeed"
          values={{
            title,
            span: (...chunks) => (
              <Text
                element="span"
                bold
                large
                gray
              >
                {chunks}
              </Text>
            ),
            strong: (...chunks) => (
              <strong>
                {chunks}
              </strong>
            ),
          }}
        />
      </Text>

      <Button
        loading={isLoading}
        disabled={isLoading}
        onClick={() => deleteRSSFeed(id)}
      >
        <FormattedMessage id="delete" />
      </Button>

      <ShouldRender condition={!!isError}>
        <Message negative>
          <Message.Content>
            <FormattedMessage id={error?.message} />
          </Message.Content>
        </Message>
      </ShouldRender>
    </div>
  );
};
